<template>
  <section id="landing__introduction" class="section">
    <div class="container">
      <p class="introduction-text" v-scroll-reveal>
        We specialise in the provisioning of superior quality welding products at competitive prices. We are Ireland's national distributor for major international brands including OERLIKON, SIDERGAS, MAGMAWELD, K-TIG, LORCH, WELDLINE, OXFORD and SGS Gases.
      </p>
    </div>
  </section>
</template>
<script>
export default {};
</script>
<style lang="scss">
.introduction-text {
  font-size: 1.33rem;
  text-align: justify;
  text-justify: inter-word;
  padding: 5em 0;
  margin: 0;
  font-style: italic;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
}
</style>